// Activate Code Bulk
export const ACTIVATE_CODE_BULK_REQUEST = 'ACTIVATE_CODE_BULK_REQUEST';
export const ACTIVATE_CODE_BULK_DONE = 'ACTIVATE_CODE_BULK_DONE';
export const ACTIVATE_CODE_BULK_FAILED = 'ACTIVATE_CODE_BULK_FAILED';
